import React, { useState } from "react";
import * as Yup from "yup";
import {
  Form as BaseForm,
  TextField,
  SubmitButton,
  CancelPopupButton,
} from "../../../ui/FormElement";
import { useEnterpriseContext } from "../../../contexts/EnterpriseContext";

export default function CreateForm({ closeForm }) {
  let FormSchema = Yup.object().shape({
    title: Yup.string().required("Enterprise name is required"),
  });

  let [loader, setLoader] = useState(false);

  const { dispatch, state, actions } = useEnterpriseContext();

  const [formData, setFormData] = useState({
    title: "",
  });

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);

    actions.addEnterprise(dispatch, values, (id) => {
      setLoader(false);
      closeForm();
      actions.editEnterprise(id);
    });
  };

  return (
    <BaseForm
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      <TextField
        name="title"
        label={
          <>
            <span>Company Name</span>
            <abbr title="required">*</abbr>
          </>
        }
      />

      <div className="text-center mt50 mb30">
        <CancelPopupButton
          className="btn btn-primary btn-outline mr5 ml5 width-120"
          title="Cancel"
          onClick={closeForm}
        />
        <SubmitButton
          title={loader ? "Please, wait ..." : "Send"}
          className={`btn width-120 btn-primary submit-button mr5 ml5 ${
            loader ? "not-possible-click" : ""
          }`}
        />
      </div>
    </BaseForm>
  );
}
